import React from "react";
import * as S from "../styles";

const ListsSection = ({
  blockLists,
  listTitles,
  draggedList,
  activeListDropZone,
  newListTitle,
  showAddListModal,
  handleListTitleChange,
  handleListTitleBlur,
  handleDeleteList,
  handleListDragStart,
  handleListDragEnd,
  handleListZoneDragOver,
  handleListZoneDragLeave,
  handleListZoneDrop,
  setNewListTitle,
  setShowAddListModal,
  handleCreateNewList,
}) => {
  return (
    <div>
      {blockLists.length === 0 ? (
        <p style={{ color: "#999", fontSize: "14px" }}>
          Нет привязанных списков
        </p>
      ) : (
        <S.ListList>
          <S.DropZone
            $active={draggedList !== null}
            $isOver={activeListDropZone === 0}
            onDragOver={(e) => handleListZoneDragOver(e, 0)}
            onDragLeave={() => handleListZoneDragLeave(0)}
            onDrop={(e) => handleListZoneDrop(e, 0)}
          >
            {activeListDropZone === 0
              ? "Вставить в начало"
              : draggedList !== null
                ? "Зона переноса"
                : ""}
          </S.DropZone>
          {blockLists.map((r, index) => (
            <React.Fragment key={r.list_id}>
              <S.ListItem
                draggable
                onDragStart={(e) => handleListDragStart(e, r.list_id)}
                onDragEnd={handleListDragEnd}
                style={{
                  opacity: draggedList === r.list_id ? 0.4 : 1,
                }}
              >
                <S.DragHandle>{r.display_order + 1}</S.DragHandle>
                <S.ListTitleInput
                  type="text"
                  value={listTitles[r.list_id] || r.title || ""}
                  onChange={(e) =>
                    handleListTitleChange(r.list_id, e.target.value)
                  }
                  onBlur={(e) => handleListTitleBlur(r.list_id, e.target.value)}
                  placeholder="Заголовок списка"
                />
                <S.DeleteButton onClick={() => handleDeleteList(r.list_id)}>
                  Удалить
                </S.DeleteButton>
              </S.ListItem>

              <S.DropZone
                $active={draggedList !== null}
                $isOver={activeListDropZone === index + 1}
                onDragOver={(e) => handleListZoneDragOver(e, index + 1)}
                onDragLeave={() => handleListZoneDragLeave(index + 1)}
                onDrop={(e) => handleListZoneDrop(e, index + 1)}
              >
                {activeListDropZone === index + 1
                  ? index === blockLists.length - 1
                    ? "Вставить в конец"
                    : "Вставить сюда"
                  : draggedList !== null
                    ? "Зона переноса"
                    : ""}
              </S.DropZone>
            </React.Fragment>
          ))}
        </S.ListList>
      )}

      <S.AddButton onClick={() => setShowAddListModal(true)}>
        Добавить термин
      </S.AddButton>

      {/* Add List Modal */}
      {showAddListModal && (
        <S.ModalOverlay onClick={() => setShowAddListModal(false)}>
          <S.Modal onClick={(e) => e.stopPropagation()}>
            <S.ModalTitle>Добавление термина</S.ModalTitle>
            <S.FormGroup>
              <S.Input
                type="text"
                value={newListTitle}
                onChange={(e) => setNewListTitle(e.target.value)}
                placeholder="Название термина"
              />
            </S.FormGroup>

            <S.ModalActions>
              <S.CancelButton onClick={() => setShowAddListModal(false)}>
                Отменить
              </S.CancelButton>
              <S.ConfirmButton onClick={handleCreateNewList}>
                Сохранить
              </S.ConfirmButton>
            </S.ModalActions>
          </S.Modal>
        </S.ModalOverlay>
      )}
    </div>
  );
};

export default ListsSection;
